const GENERATED_ROW_SELECTOR = "tr[data-office-empty-row='true']";

const tableColumnCount = (table) => {
  const headerRows = Array.from(table.tHead?.rows || []);
  const cells = Array.from(headerRows.at(-1)?.cells || []);

  return Math.max(
    cells.reduce((total, cell) => total + cell.colSpan, 0),
    1,
  );
};

const buildEmptyContent = (title, description, modifier = "table") => {
  const state = document.createElement("div");
  state.className = `office-empty-state office-empty-state--${modifier}`;
  state.setAttribute("role", "status");
  state.setAttribute(
    "data-testid",
    modifier === "table" ? "office-empty-table-state" : "office-empty-state",
  );
  state.dataset.officeEmptyBlock = "true";

  const icon = document.createElement("span");
  icon.className = "office-empty-state__icon";
  icon.setAttribute("aria-hidden", "true");
  icon.innerHTML = '<i class="fas fa-inbox"></i>';

  const content = document.createElement("span");
  content.className = "office-empty-state__content";

  const heading = document.createElement("strong");
  heading.className = "office-empty-state__title";
  heading.textContent = title;

  const copy = document.createElement("span");
  copy.className = "office-empty-state__description";
  copy.textContent = description;

  content.append(heading, copy);
  state.append(icon, content);

  return state;
};

const updateContainer = (container, title, description) => {
  const emptyState = container.querySelector(
    ":scope > [data-office-empty-block='true']",
  );
  const content = Array.from(container.children).filter(
    (child) => child.dataset.officeEmptyBlock !== "true",
  );

  if (content.length > 0) {
    emptyState?.remove();
    return;
  }

  if (!emptyState) {
    container.append(buildEmptyContent(title, description, "compact"));
  }
};

const updateTableBody = (body, title, description) => {
  if (body.dataset.emptyStateIgnore === "true") return;

  const generatedRow = body.querySelector(`:scope > ${GENERATED_ROW_SELECTOR}`);
  const contentRows = Array.from(body.children).filter(
    (row) => !row.matches(GENERATED_ROW_SELECTOR),
  );

  if (contentRows.length > 0) {
    generatedRow?.remove();
    return;
  }

  if (generatedRow) return;

  const row = document.createElement("tr");
  row.dataset.officeEmptyRow = "true";
  row.className = "office-empty-table-row";

  const cell = document.createElement("td");
  cell.colSpan = tableColumnCount(body.closest("table"));
  cell.append(buildEmptyContent(title, description));
  row.append(cell);
  body.append(row);
};

document.addEventListener("DOMContentLoaded", () => {
  const officeBody = document.querySelector(".office-body");
  const content = document.querySelector(".office-page__content");

  if (!officeBody || !content) return;

  const hasActiveFilters = Array.from(
    new URLSearchParams(window.location.search).entries(),
  ).some(([key, value]) => key.startsWith("q[") && value.trim().length > 0);
  const title = hasActiveFilters
    ? officeBody.dataset.emptyStateFilteredTitle
    : officeBody.dataset.emptyStateTitle;
  const description = hasActiveFilters
    ? officeBody.dataset.emptyStateFilteredDescription
    : officeBody.dataset.emptyStateDescription;
  let scheduled = false;

  const refresh = () => {
    scheduled = false;
    content.querySelectorAll("table tbody").forEach((body) => {
      updateTableBody(body, title, description);
    });
    content
      .querySelectorAll("[data-empty-state-container='true']")
      .forEach((container) => updateContainer(container, title, description));
  };

  const scheduleRefresh = () => {
    if (scheduled) return;

    scheduled = true;
    window.requestAnimationFrame(refresh);
  };

  refresh();
  new MutationObserver(scheduleRefresh).observe(content, {
    childList: true,
    subtree: true,
  });
});
